// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-login[data-v-8a6fa1ec]{height:100px}", ""]);
// Exports
module.exports = exports;
